var React = require('react');

function SocialFacebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M631.9,1874.6v-855.1h287l43-333.2h-330V473.5c0-96.5,26.8-162.2,165.2-162.2l176.5-0.1v-298\n\tC943,9.1,838.2,0,716.4,0C461.9,0,287.8,155.3,287.8,440.5v245.8H0v333.2h287.8v855.1L631.9,1874.6z M631.9,1874.6"}));
}

SocialFacebook.defaultProps = {"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 973.5 1874.6","enableBackground":"new 0 0 973.5 1874.6","xmlSpace":"preserve"};

module.exports = SocialFacebook;

SocialFacebook.default = SocialFacebook;
